import React from 'react';
import './LoaderCustom.css';

function LoaderCustomFixed() {
    return <div className="loader-custom-fixed"></div>;
}

export default LoaderCustomFixed;
